// removed by extract-text-webpack-plugin
module.exports = {"withBorder":"src-pages-features-design-style----interfacesBlock-module---withBorder---30-PJ borderColor-smoke borderStyle-solid borderTopWidth-1 borderWidth-0 paddingTop-xl breakPointM-paddingTop-0 breakPointM-borderTopWidth-0"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/features/design/style/interfacesBlock.module.css
// module id = 753
// module chunks = 168014880390238 244429959259914